import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BillPayerModel, {type BillPayer} from 'web-app/react/entities/bill-payers/model';
import Child from 'web-app/react/entities/children/model';

export const fetchDebtReportOverview = (
    institutionId: string,
    asOf: string,
    includeCreditNotesAndCancelledInvoicesInBalance: boolean,
) =>
    RESTClient.getAuthenticatedObservable(`v2/invoicing/${institutionId}/debtReport/chart`, {
        asOf,
        includeCreditNotesAndCancelledInvoicesInBalance,
    });

const BILL_PAYERS_FETCH_LIMIT = 250;

type BillPayerData = {
    billPayers: BillPayer[];
    children: any[]; // TODO: Maybe add a type here
};

// Recursively fetches until no pages are left
const fetchBillPayers = (
    institutionId: string,
    offset: number,
    limit: number,
    existingData: BillPayerData,
): Promise<BillPayerData> => {
    return RESTClient.getAuthenticated(`v2/invoicing/${institutionId}/debtReport/structure`, {
        offset,
        limit,
    }).then(result => {
        const billPayers = Object.values(result.billPayers).map(billPayer => BillPayerModel.fromAPI(billPayer));
        const children = Object.values(result.children).map(child => Child.fromAPI(child));

        const collectedData = {
            billPayers: [...existingData.billPayers, ...billPayers],
            children: [...existingData.children, ...children],
        };

        if (billPayers.length === BILL_PAYERS_FETCH_LIMIT) {
            return fetchBillPayers(institutionId, offset + limit, limit, collectedData);
        } else {
            return {
                billPayers: collectedData.billPayers,
                children: collectedData.children,
            };
        }
    });
};

export const fetchAllBillPayers = (institutionId: string) => {
    return fetchBillPayers(institutionId, 0, BILL_PAYERS_FETCH_LIMIT, {billPayers: [], children: []});
};

export const fetchBalanceInformationForBillPayers = (
    institutionId: string,
    asOf: string, // YYYY-MM-DD
    includeCreditNotesAndCancelledInvoicesInBalance: boolean,
    billPayerIds: string[],
    expectedPaymentIds?: string[],
    unexpectedPaymentIds?: string[],
    expectedInvoiceIds?: string[],
    unexpectedInvoiceIds?: string[],
) => {
    return RESTClient.getAuthenticated(`v2/invoicing/${institutionId}/debtReport/details`, {
        billPayerIds,
        asOf,
        includeCreditNotesAndCancelledInvoicesInBalance,
        expectedPaymentIds,
        unexpectedPaymentIds,
        expectedInvoiceIds,
        unexpectedInvoiceIds,
    }).then(result => {
        return result;
    });
};
